import { instance } from '@/lib';

const saveBlobDirect = (blob: Blob, filename: string) => {
  // create file link in browser's memory
  const href = URL.createObjectURL(blob);

  // create "a" HTML element with href to file & click
  const link = document.createElement('a');
  link.href = href;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();

  // clean up "a" element & remove ObjectURL
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

export const downloadSettlementReport = async (
  id: string,
  fileName: string,
  includeDetails = false
) => {
  const response = await instance.get(`/settlement-imports/${id}/report`, {
    params: { includeDetails },
    responseType: 'blob',
  });

  const reportType = includeDetails ? 'szczegolowe' : 'uproszczone';
  const reportFileName = `rozliczenie_${reportType}_${fileName}_${
    new Date().toISOString().split('T')[0]
  }.pdf`;
  saveBlobDirect(response.data, reportFileName);
};
